import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "..";
import { ACCEPT_OFFER_DETAILS, ADD_CANDIDATE_DETAILS, APPLY_CANDIDATE, CREATE_JOB_POSTING, CREATE_JOB_REQUISITION, CREATE_OFFER, DECLINE_OFFER_DETAILS, GET_ALLCANDIDATES_LIST, GET_ASSIGNED_JOBREQUISITION, GET_CANDIDATE_DETAILS, GET_INTERVIEW_CANDIDATE_DETAILS, GET_INTERVIEW_SCHEDULED_CANDIDATES, GET_JOB_POSTING_INSIGHTS, GET_JOB_REQUISITIONS, GET_JOBPOSTINGS, GET_PUBLISH_JOBDETAILS, GET_SELECTED_CANDIDATES, GET_SINGLE_JOB_REQUISITION, SAVE_OFFER_DRAFT, SCHEDULE_INTERVIEW, SEND_OFFER, SEND_OFFER_DETAILS, SUBMIT_INTERVIEW_FEEDBACK, UPDATE_CANDIDATE_STATUS, UPDATE_JOB_DETAILS, UPDATE_PUBLISH_JOB_DETAILS } from "../Queries/Hiring";
import { useQuery } from "@apollo/client";
import { setLoader } from "./loaderSlice";

export const getJobRequisitionsAsync = createAsyncThunk(
    'hiring/getJobRequisitions',
    async (variables, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoader(true))
            const { data } = await client.query({
                query: GET_JOB_REQUISITIONS,
                variables,
                fetchPolicy: 'no-cache'
            })
            const result = data?.getAllJobRequisition || [];
            return {
                status: result.status,
                message: result.message,
                response: result.response
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
        finally {
            dispatch(setLoader(false))
        }
    }
);

export const createJobAsync = createAsyncThunk(
    'hiring/createJobRequisition',
    async (formData, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: CREATE_JOB_REQUISITION,
                variables: {
                    input: formData
                }
            })
            const result = data?.createJobRequisition || [];
            return {
                status: result.status,
                message: result.message,
                response: result.response
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const getSingleJobRequisitionAsync = createAsyncThunk(
    'hiring/getSingleJobRequisition',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoader(true))
            const { data } = await client.query({
                query: GET_SINGLE_JOB_REQUISITION,
                variables: { id: id },
                fetchPolicy: 'no-cache'
            })
            const result = data?.getSingleJobRequisition;
            return {
                status: result.status,
                message: result.message,
                response: result.response
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
        finally {
            dispatch(setLoader(false))
        }
    }
);

export const updateJobRequisitionAsync = createAsyncThunk(
    'hiring/updateRequisition',
    async ({ id, data: payload }, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: UPDATE_JOB_DETAILS,
                variables: { id, input: payload }
            });
            const result = data.updateJobRequisition
            return {
                status: result.status,
                message: result.message,
                response: result.response
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updatePublishJobRequisitionAsync = createAsyncThunk(
    'hiring/updatePublishJobRequisitionAsync',
    async ({ id, data: payload }, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: UPDATE_PUBLISH_JOB_DETAILS,
                variables: { id, input: payload }
            });
            const result = data.updatePublishJobRequisition
            return {
                status: result.status,
                message: result.message,
                response: result.response
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const createJobPostingAsync = createAsyncThunk(
    "hiring/jobPosting",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: CREATE_JOB_POSTING,
                variables: {
                    input: payload
                }
            })
            const response = data.createJobPosting
            return response;
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
    }

);

export const getJobPostingAsync = createAsyncThunk(
    'hiring/getJobPostings',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoader(true))
            const { data } = await client.query({
                query: GET_JOBPOSTINGS,
                fetchPolicy: 'no-cache'
            })
            const result = data?.getAllJobPostings || [];
            return {
                status: result.status,
                message: result.message,
                response: result.response
            }
        }
        catch (error) {
            return rejectWithValue(error.message);
        }
        finally {
            dispatch(setLoader(false))
        }
    }
);

export const getPublishJobAsync = createAsyncThunk(
    'hiring/getPublishJob',
    async (slug, { rejectWithValue }) => {
        try {
            const { data } = await client.query({
                query: GET_PUBLISH_JOBDETAILS,
                variables: { slug },
                fetchPolicy: "no-cache"
            })
            const response = data.PublicJobBySlug
            return response
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
    }
);

export const applyJobAsync = createAsyncThunk(
    "hiring/applyJob",
    async (formData, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: APPLY_CANDIDATE,
                variables: {
                    firstName: formData.firstName,
                    lastName: formData.lastName,
                    email: formData.email,
                    phone: formData.phone,
                    experience: formData.experience,
                    currentCTC: formData.currentCTC,
                    expectedCTC: formData.expectedCTC,
                    resumeUrl: formData.resumeUrl,
                    appliedSlug: formData.appliedSlug,
                    source: formData.source,
                }
            });

            return data.ApplyCandidate;
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const getJobPostingInsightsAsync = createAsyncThunk(
    "hiring/JobPostingInsights",
    async (requisitionId, { rejectWithValue }) => {
        try {
            const { data } = await client.query({
                query: GET_JOB_POSTING_INSIGHTS,
                variables: { requisitionId },
                fetchPolicy: "no-cache"
            })

            const result = data.JobPostingInsightsData;
            return result
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
    }
);

export const getCandidateListAsync = createAsyncThunk(
    "hiring/getCandidateList",
    async ({ status, source, jobTitle, department, experienceFrom, experienceTo, shift, result, requisitionId }, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoader(true))
            const { data } = await client.query({
                query: GET_ALLCANDIDATES_LIST,
                variables: {
                    status: status,
                    source: source,
                    jobTitle: jobTitle,
                    department: department,
                    experienceFrom: experienceFrom,
                    experienceTo: experienceTo,
                    shift: shift,
                    result: result,
                    requisitionId: requisitionId

                },
                fetchPolicy: 'no-cache'
            })
            const response = data.getAllCandidateList
            return response
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
        finally {
            dispatch(setLoader(false))
        }
    }
);

export const updateCandidateStatusAsync = createAsyncThunk(
    "hiring/updateCandidateStatus",
    async ({ candidateId, status, stage, comments, editedBy }, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: UPDATE_CANDIDATE_STATUS,
                variables: { candidateId, status, stage, comments, editedBy },
                fetchPolicy: "no-cache"
            });

            return data.UpdateCandidateStatus;
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const AddCandidateDetailsAsync = createAsyncThunk(
    "hiring/addCandidate",
    async (payload, { rejectWithValue }) => {
        try {
            const { data,errors } = await client.mutate({
                mutation: ADD_CANDIDATE_DETAILS,
                variables: {
                    input: payload
                }
            })
            if (errors && errors.length > 0) {
        return rejectWithValue(errors[0].message);
      }

            return data.addCandidateDetails
        }
        catch (error) {
            rejectWithValue(error.message)
        }
    }
);

export const getSingleCandidateDetails = createAsyncThunk(
    'hiring/singleCandidate',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoader(true))
            const { data } = await client.query({
                query: GET_CANDIDATE_DETAILS,
                variables: { id },
                fetchPolicy: "no-cache"
            })
            const response = data.getCandidateDetails;
            return response;
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
        finally {
            dispatch(setLoader(false))
        }
    }
);

export const getInterviewCandidateDetails = createAsyncThunk(
    'hiring/interviewCandidate',
    async (candidateId, { rejectWithValue }) => {
        try {
            const { data } = await client.query({
                query: GET_INTERVIEW_CANDIDATE_DETAILS,
                variables: { candidateId },
                fetchPolicy: "no-cache"
            });

            return data.getInterviewCandidates;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const InterviewSchedule = createAsyncThunk(
    "hiring/InterviewSchedule",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: SCHEDULE_INTERVIEW,
                variables: { input: payload }
            })
            const response = data?.ScheduleInterview
            return response
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
    }
);

export const InterviewFeedback = createAsyncThunk(
    "hiring/IterviewFeedback",
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: SUBMIT_INTERVIEW_FEEDBACK,
                variables: { input: payload }
            })
            const response = data?.SubmitInterviewFeedback
            return response
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
    }
);

export const fetchSelectedCandidates = createAsyncThunk(
    "hiring/fetchSelectedCandidates",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoader(true));
            const response = await client.query({ query: GET_SELECTED_CANDIDATES, fetchPolicy: "no-cache" });
            return response.data.GetSelectedCandidates;
        } catch (error) {
            return rejectWithValue(error.message);
        }
        finally {
            dispatch(setLoader(false));
        }
    }
);

export const saveOfferDraftAsync = createAsyncThunk(
    "offer/saveDraft",
    async (input) => {
        const { data } = await client.mutate({
            mutation: CREATE_OFFER,
            variables: { input }
        });
        return data.createOffer;
    }
);

export const sendOfferLetterAsync = createAsyncThunk(
    "offer/sendLetter",
    async (input, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: SEND_OFFER_DETAILS,
                variables: { input }
            });
            return data.sendOffer;
        }
        catch (error) {
            return rejectWithValue(error.message)
        }

    }
);

export const AcceptOfferLetterAsync = createAsyncThunk(
    "offer/sendLetter",
    async (offerId, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: ACCEPT_OFFER_DETAILS,
                variables: { offerId }
            });
            return data.acceptOffer;
        }
        catch (error) {
            return rejectWithValue(error.message)
        }

    }
);

export const DeclineOfferLetterAsync = createAsyncThunk(
    "offer/sendLetter",
    async (offerId, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: DECLINE_OFFER_DETAILS,
                variables: { offerId }
            });
            return data.declineOffer;
        }
        catch (error) {
            return rejectWithValue(error.message)
        }

    }
);

export const fetchScheduledCandidates = createAsyncThunk(
    "candidates/fetchScheduledCandidates",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            dispatch(setLoader(true))
            const { data } = await client.query({
                query: GET_INTERVIEW_SCHEDULED_CANDIDATES,
                fetchPolicy: "no-cache"
            })

            const result = data?.getInterviewScheduleCandidates
            return result
        }
        catch (error) {
            return rejectWithValue(error.message)
        }
        finally {
            dispatch(setLoader(false))
        }
    }
);


const initialState = {
    jobRequisition: [],
    singleJob: {},
    jobPosting: [],
    publishJob: [],
    insights: {},
    candidateList: [],
    singleCandidate: {},
    interview: {},
    selectedCandidates: [],
    selectedCandidate: null,
    interviewList: [],
    offerDetails: []
}

const hiringSlice = createSlice({
    name: "hiring",
    initialState,
    reducers: {
        setSelectedCandidate: (state, action) => {
            state.selectedCandidate = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getJobRequisitionsAsync.fulfilled, (state, action) => {
                state.jobRequisition = action.payload.response;
            })
            .addCase(createJobAsync.fulfilled, (state, action) => {
                state.jobRequisition.push(action.payload.response);
            })
            .addCase(getSingleJobRequisitionAsync.fulfilled, (state, action) => {
                state.singleJob = action.payload.response;
            })
            .addCase(updateJobRequisitionAsync.fulfilled, (state, action) => {
                state.jobRequisition = state.jobRequisition.map((job) => job.id === action.payload.id ? action.payload : job)
            })
            .addCase(updatePublishJobRequisitionAsync.fulfilled, (state, action) => {
                state.jobPosting = state.jobPosting.map((job) => job.id === action.payload.id ? action.payload : job)
            })
            .addCase(createJobPostingAsync.fulfilled, (state, action) => {
                state.jobPosting.push(action.payload)
            })
            .addCase(getJobPostingAsync.fulfilled, (state, action) => {
                state.jobPosting = action.payload.response
            })
            .addCase(getPublishJobAsync.fulfilled, (state, action) => {
                state.publishJob = action.payload
            })
            .addCase(getJobPostingInsightsAsync.fulfilled, (state, action) => {
                state.insights = action.payload;
            })
            .addCase(getCandidateListAsync.fulfilled, (state, action) => {
                state.candidateList = action.payload
            })
            .addCase(updateCandidateStatusAsync.fulfilled, (state, action) => {
                const updated = action.payload;
                if (!updated) return;

                if (state.singleCandidate?.candidateId === updated.candidateId) {
                    state.singleCandidate = {
                        ...state.singleCandidate,
                        ...updated
                    };
                }
                state.candidateList = state.candidateList.map(c =>
                    c.candidateId === updated.candidateId
                        ? { ...c, ...updated }
                        : c
                );
            })
            .addCase(AddCandidateDetailsAsync.fulfilled, (state, action) => {
                state.candidateList.push(action.payload)
            })
            .addCase(getSingleCandidateDetails.fulfilled, (state, action) => {
                state.singleCandidate = action.payload;
            })
            .addCase(getInterviewCandidateDetails.fulfilled, (state, action) => {
                state.interview = action.payload;
            })
            .addCase(fetchSelectedCandidates.fulfilled, (state, action) => {
                state.selectedCandidates = action.payload;
            })
            .addCase(fetchScheduledCandidates.fulfilled, (state, action) => {
                state.interviewList = action.payload
            })
            .addCase(saveOfferDraftAsync.fulfilled, (state, action) => {
                state.offerDetails = action.payload
            })
    }

});

export const { setSelectedCandidate } = hiringSlice.actions;
export default hiringSlice.reducer;